import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckIcon } from '@heroicons/react/24/solid';
import './SizePicker.css';

const SizePicker = ({ selectedSize, onSizeChange, disabled = false }) => {
    const { t } = useTranslation();

    const sizes = [
        { code: 'S', dimensions: '6x6 cm', label: t('sizePicker.sizeS', 'S (6x6 cm)') },
        { code: 'M', dimensions: '8x8 cm', label: t('sizePicker.sizeM', 'M (8x8 cm)') },
        { code: 'L', dimensions: '10x10 cm', label: t('sizePicker.sizeL', 'L (10x10 cm)') }
    ];

    return (
        <div className="size-picker">
            <label className="size-picker-label" data-testid="size-picker-label">
                {t('sizePicker.title', 'Избери Големина')}
            </label>
            <div className="size-picker-options" data-testid="size-picker-container">
                {sizes.map((size) => {
                    const isSelected = selectedSize === size.code;
                    return (
                        <button
                            key={size.code}
                            type="button"
                            onClick={() => onSizeChange(size.code)}
                            disabled={disabled}
                            className={`size-picker-option ${isSelected ? 'is-selected' : ''}`}
                            aria-pressed={isSelected}
                            data-testid={`size-option-${size.code}`}
                        >
                            <span className="size-picker-code">{size.code}</span>
                            <span className="size-picker-dimensions">{size.dimensions}</span>
                            {isSelected && (
                                <span className="size-picker-check" aria-hidden="true">
                                    <CheckIcon />
                                </span>
                            )}
                        </button>
                    );
                })}
            </div>
            <p className="size-picker-help" data-testid="size-picker-help">
                {t('sizePicker.helpText', 'Изберете ја големината на вашиот QR производ')}
            </p>
        </div>
    );
};

export default SizePicker;
